import { render, staticRenderFns } from "./AddColorModal.vue?vue&type=template&id=0ffb6176&scoped=true"
import script from "./AddColorModal.vue?vue&type=script&lang=js"
export * from "./AddColorModal.vue?vue&type=script&lang=js"
import style0 from "./AddColorModal.vue?vue&type=style&index=0&id=0ffb6176&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb6176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffb6176')) {
      api.createRecord('0ffb6176', component.options)
    } else {
      api.reload('0ffb6176', component.options)
    }
    module.hot.accept("./AddColorModal.vue?vue&type=template&id=0ffb6176&scoped=true", function () {
      api.rerender('0ffb6176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/AddColorModal.vue"
export default component.exports